import { render, staticRenderFns } from "./SelfService.vue?vue&type=template&id=97c9575c&scoped=true"
import script from "./SelfService.vue?vue&type=script&lang=js"
export * from "./SelfService.vue?vue&type=script&lang=js"
import style0 from "./SelfService.vue?vue&type=style&index=0&id=97c9575c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c9575c",
  null
  
)

export default component.exports